const FULFILLMENT_SELECT_SELECTOR = '[data-fulfillment-center-select]';
const CHECKOUT_CONTAINER_SELECTOR = '[data-fulfillment-checkout-container]';

/**
 * Update every fulfillment center dropdown on the page.
 */
function syncFulfillmentSelects(value) {
  document
    .querySelectorAll(FULFILLMENT_SELECT_SELECTOR)
    .forEach((select) => {
      select.value = value || '';
      select.setCustomValidity('');
    });
}

/**
 * Update every checkout area.
 *
 * Pass the actual fulfillment center value directly instead of
 * searching the DOM for one.
 */
function updateFulfillmentState(value) {
  const hasSelection = Boolean(value && value.trim());

  console.log(
    '[Fulfillment Center] Updating checkout state:',
    hasSelection ? `ENABLED (${value})` : 'DISABLED'
  );

  document
    .querySelectorAll(CHECKOUT_CONTAINER_SELECTOR)
    .forEach((container) => {
      container.dataset.fulfillmentRequired = hasSelection
        ? 'false'
        : 'true';

      /*
       * Force the accelerated checkout area to update immediately.
       */
      const acceleratedButtons = container.querySelector(
        '.additional-checkout-buttons'
      );

      if (acceleratedButtons) {
        acceleratedButtons.style.pointerEvents = hasSelection
          ? 'auto'
          : 'none';

        acceleratedButtons.style.opacity = hasSelection
          ? '1'
          : '0.45';
      }

      /*
       * Update the normal checkout button appearance.
       */
      const checkoutButton = container.querySelector(
        '.cart__checkout-button'
      );

      if (checkoutButton) {
        checkoutButton.style.opacity = hasSelection
          ? '1'
          : '0.6';

        checkoutButton.style.cursor = hasSelection
          ? 'pointer'
          : 'not-allowed';
      }
    });
}

/**
 * Get the fulfillment center directly from Shopify's cart.
 *
 * This is the source of truth and survives Horizon cart re-renders.
 */
async function getCartFulfillmentCenter() {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error('Unable to get cart.');
    }

    const cart = await response.json();

    return (
      cart.attributes?.['Training Center'] || ''
    ).trim();
  } catch (error) {
    console.error(
      '[Fulfillment Center] Unable to read cart:',
      error
    );

    return '';
  }
}

/**
 * Save the fulfillment center to Shopify.
 */
async function saveFulfillmentCenter(value) {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        'Training Center': value,
      },
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to save Fulfillment Center.');
  }

  const cart = await response.json();

  return (
    cart.attributes?.['Training Center'] || ''
  ).trim();
}

/**
 * Handle fulfillment center changes.
 *
 * Using event delegation means this continues working when Horizon
 * replaces the cart drawer HTML.
 */
document.addEventListener('change', async (event) => {
  const select = event.target.closest(
    FULFILLMENT_SELECT_SELECTOR
  );

  if (!select) return;

  const selectedValue = select.value.trim();

  console.log(
    '[Fulfillment Center] Customer selected:',
    selectedValue
  );

  /*
   * Immediately update everything.
   * Do not wait for Shopify.
   */
  syncFulfillmentSelects(selectedValue);
  updateFulfillmentState(selectedValue);

  try {
    /*
     * Save to Shopify and use Shopify's returned value as
     * the authoritative value.
     */
    const savedValue = await saveFulfillmentCenter(
      selectedValue
    );

    console.log(
      '[Fulfillment Center] Shopify saved:',
      savedValue
    );

    syncFulfillmentSelects(savedValue);
    updateFulfillmentState(savedValue);

    /*
     * Horizon may re-render the cart drawer after the cart update.
     * Re-read Shopify's cart after rendering has settled.
     */
    setTimeout(refreshFulfillmentState, 100);
    setTimeout(refreshFulfillmentState, 500);
    setTimeout(refreshFulfillmentState, 1000);
  } catch (error) {
    console.error(
      '[Fulfillment Center] Failed to save:',
      error
    );
  }
});

/**
 * Read the current Shopify cart and apply its state to the page.
 */
async function refreshFulfillmentState() {
  const fulfillmentCenter =
    await getCartFulfillmentCenter();

  console.log(
    '[Fulfillment Center] Refreshing from cart:',
    fulfillmentCenter || 'No selection'
  );

  syncFulfillmentSelects(fulfillmentCenter);
  updateFulfillmentState(fulfillmentCenter);
}

/**
 * Horizon dynamically adds and replaces cart drawer HTML.
 *
 * When that happens, reapply the state after the DOM update.
 */
let refreshTimeout;

const observer = new MutationObserver(() => {
  clearTimeout(refreshTimeout);

  refreshTimeout = setTimeout(() => {
    refreshFulfillmentState();
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

/**
 * Set the initial state from the Shopify cart.
 */
refreshFulfillmentState();

/**
 * Prevent the regular Checkout button if no fulfillment center
 * exists in the actual Shopify cart.
 */
document.addEventListener(
  'click',
  async (event) => {
    const button = event.target.closest(
      '#checkout, [name="checkout"]'
    );

    if (!button) return;

    const fulfillmentCenter =
      await getCartFulfillmentCenter();

    if (fulfillmentCenter) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const select = document.querySelector(
      FULFILLMENT_SELECT_SELECTOR
    );

    if (select) {
      select.setCustomValidity(
        'Please select a Training Center before checking out.'
      );

      select.reportValidity();
      select.focus();
    }
  },
  true
);